import styled from 'styled-components';

export const TextContainer = styled.div`
  margin: 2em 0;
`;
